<!-- <section class="contactForm" fxLayout="column" fxLayoutGap.gt-md="50px">
      <div fxLayout="row" fxLayoutAlign="center start">
            <div fxFlex="98%" fxFlex.gt-md="92%" fxLayout="row wrap" fxLayoutGap.gt-md="50px">
            <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 50px)" fxLayoutAlign="center center" class="conIf">
                  <div fxLayout="column">
                  <div class="textRight">
                        <img src="https://static.wixstatic.com/media/cf6097_c3a16b7fc3234144be490f802d75f6e8~mv2.png/v1/fill/w_115,h_115,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/GrisonCreamery-Final_web.png" alt="">
                  </div>
                  <h4>Get in touch with<br>any questions</h4>
                  <p>Address</p>
                  <ul>
                        <li>RR 1 Box 422</li>
                        <li>Ava, MO 65608</li>
                  </ul>
                  <p>Contact</p>
                  <ul>
                        <li>
                        <a href="tel:+417-543-6809">417-543-6809</a>
                        </li>
                        <li>
                        <a href="mailto:grisoncreamery@yahoo.com">grisoncreamery@yahoo.com</a>
                        </li>
                  </ul>
                  </div>
            </div>
            <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 50px)">
                  <h6>ֿPlease fill out the form:</h6>
                  <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
                        <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                        <mat-label>First Name</mat-label>
                              <mat-form-field appearance="outline">
                              <input matInput >
                              </mat-form-field>
                        </div>
                        <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                        <mat-label>Last Name</mat-label>
                              <mat-form-field appearance="outline">
                              <input matInput >
                              </mat-form-field>
                        </div>
                  </div>
                  <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
                  <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                        <mat-label>Email</mat-label>
                        <mat-form-field appearance="outline">
                        <input matInput required>
                        </mat-form-field>
                  </div>
                  <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                        <mat-label>Phone</mat-label>
                        <mat-form-field appearance="outline">
                        <input matInput >
                        </mat-form-field>
                  </div>
                  </div>
                  <div fxLayout="row wrap" fxLayoutGap.gt-md="30px">
                  <div fxLayout="column" fxFlex="100%" fxFlex.gt-md="calc(50% - 30px)">
                        <mat-label>Add a message</mat-label>
                        <mat-form-field appearance="outline">
                        <textarea matInput></textarea>
                        </mat-form-field>
                  </div>
                  </div>
                  <div fxLayout="row">
                        <div fxLayout="column" fxFlex="100%" fxLayoutAlign="start end">
                        <button class="btnDefault">Send</button>
                        </div>
                  </div>
            </div>
            </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center start" class="conMap">
            <div fxFlex="98%" fxFlex.gt-md="92%" fxLayout="row">
            <iframe fxFlex="100%" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3188.5381683489163!2d-92.78066492361509!3d36.9492018592853!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87cf9502a2ac37a5%3A0x1dd79d24bc2a8a84!2sGrison%20Dairy%20%26%20Creamery!5e0!3m2!1sen!2sin!4v1726914383088!5m2!1sen!2sin" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
            </div>
      </div>
</section> -->
<footer class="footer-excep">
      <ng-container *ngIf="!!featureTags && featureTags['ftag_powered_by_fds']">
            <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" class="mobileChanges">
                  <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
                        {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
                  <a href="https://farmdeliverysoftware.com/" *ngIf="storeDetails.show_powered_by_link === 1" class="brandLink" target="_blank">Powered by Smart FDS</a>
            </div>
      </ng-container>
      <ng-container *ngIf="!!featureTags && !featureTags['ftag_powered_by_fds']">
            <p *ngIf="storeDetailsJson['second_footer']" ngClass.xs="mt-1">
                  {{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
      </ng-container>    
</footer>